import React, { useState } from 'react';
import { Grid, TextField, makeStyles, Button, withStyles } from '@material-ui/core';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormLabel from '@material-ui/core/FormLabel';
import { useHistory } from 'react-router-dom';
import { updateParticipantPlanning, sendEmailTemplate } from '../../../../store/actions/participant/experience';
import { useDispatch, useSelector } from 'react-redux';
import { Loading } from '../../../atoms/commonLoadings';

const useStyles = makeStyles(() => ({
    container: {
        flex: 1,
        marginTop: 17,
        paddingLeft: 20,
        paddingRight: 20
    },
    header: {
        fontSize: '48px!important',
        fontFamily: 'Spartan-bold',
        fontWeight: 400,
        lineHeight: 1.3,
        letterSpacing: '0em',
        color: '#212D40',
        textAlign: 'center',
        margin: "10px 0px"
    },
    content: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
    },
    label: {
        fontSize: 16,
        fontFamily: 'roboto-black',
        color: '#697683',
        marginTop: 40,
        marginBottom: -14,
        '& .MuiFormLabel-asterisk': {
            color: "red"
        }
    },
    box: {
        display: 'flex',
        flexDirection: 'column'
    },
    btn: {
        marginTop: 12,
        padding: '5px 42px',
        background: '#017AEF',
        color: '#fff',
        '&:hover': {
            background: '#0f9fef',
            color: '#fff',
        },
        textTransform: 'none'
    },
    btnBox: {
        width: '100%',
        maxWidth: 530,
        display: 'flex',
        justifyContent: 'flex-end',
        margin: 12
    },
}));


const CssTextField = withStyles({
    root: {
        maxWidth: 530,
        '& label.MuiFormLabel-root': {
            color: '#697683',
            fontFamily: 'roboto-black',
            fontSize: 16,
        },
        '& .MuiInputBase-input': {
            fontFamily: 'roboto-light',
            fontSize: 24,
            color: '#8F99A3'
        }
    },
})(TextField);

function PlanningStep6() {

    const classes = useStyles();
    const [hear, setHear] = useState<string>('');
    const [information, setInformation] = useState<string>('');
    const [value, setValue] = useState('No');
    const [loading, setLoading] = useState(false);
    const apolloClient = useSelector((state: any) => state.apolloClient);
    const { planning } = useSelector((state: any) => state.participant);
    const loginUserData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || "{}") : ""

    const dispatch = useDispatch();
    const history = useHistory();

    const onGoNextPage = async () => {
        setLoading(true);

        dispatch(updateParticipantPlanning('plan_to_join', value));
        // dispatch(updateParticipantPlanning('company', company));
        dispatch(updateParticipantPlanning('additional_information', information));
        dispatch(updateParticipantPlanning('description', hear));

        const request = { ...planning }
        request.plan_to_join = value;
        request.company = '';
        request.additional_information = information;
        request.description = hear;

        if (!loginUserData.disable_transactional_emails) {
            dispatch(sendEmailTemplate(apolloClient.client, request, (res: any) => {
                setLoading(false);
                if (res) {
                    history.push('/participant/planning/5')
                }
            }));
        } else {
            setLoading(false);
            history.push('/participant/planning/5')
        }
    }

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setValue((event.target as HTMLInputElement).value);
    };

    return (
        <Grid container justifyContent={'center'} className={classes.container}>
            <Grid item lg={8} md={10} sm={12} className={classes.content}>
                <p className={classes.header}>
                    No Worries.<br />
Give us a bit more info, and<br />
we&#39;ll point you in the right direction:
</p>

                <div className={classes.box}>
                    <FormLabel required className={classes.label}>Is there a specific Immersion experience you were planning to participant in?</FormLabel>
                    <RadioGroup style={{ marginTop: 14 }} row aria-label="gender" name="gender1" value={value} onChange={handleChange}>
                        <FormControlLabel value="Yes" control={<Radio color='primary' />} label="Yes" />
                        <FormControlLabel value="No" control={<Radio color='primary' />} label="No" />
                    </RadioGroup>

                    <FormLabel required className={classes.label}>Who told you about Immersion / How did you hear about us?</FormLabel>
                    <CssTextField
                        fullWidth
                        margin="normal"
                        name="linkUrl"
                        value={hear}
                        onChange={e => setHear(e.target.value)}
                    />

                    <FormLabel className={classes.label}>Any additional information you want to add?</FormLabel>

                    <CssTextField
                        fullWidth
                        margin="normal"
                        name="linkUrl"
                        value={information}
                        onChange={e => setInformation(e.target.value)}
                    />

                </div>
                {hear && !loading &&
                    <div className={classes.btnBox}>
                        <Button variant='contained' className={classes.btn} onClick={onGoNextPage}>
                            Submit
</Button>
                    </div>
                }
                {
                    loading && <Loading />
                }
            </Grid>
        </Grid>

    )
}

export default PlanningStep6;